import { Grid, Typography } from '@mui/material'
import { useCallback, useContext, useEffect, useRef, useState } from 'react'
// import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
// import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded'
import { urlConfig } from '../../../../../config/apiConfig'
import axiosInstance from '../../../../../config/axiosConfig'
import { AlertContext } from '../../../../../context/AlertContext'
import TableComponents from '../../../../TableComponents'
import { useTimezoneSelect, allTimezones } from 'react-timezone-select'
import moment from 'moment-timezone'

export default function AlarmRealTime({
    deviceId,
    deviceData,
    typeAlarm,
    connectedWB,
}) {
    const [data, setData] = useState('')
    const [dataType, setDataType] = useState('')
    const { handleOpen } = useContext(AlertContext)
    const localTimezone = localStorage.getItem('timezone')

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(5)
    const [foot, setFoot] = useState(null)
    const limitOptions = [5, 10, 25, 50, 100]

    const labelStyle = 'original'
    const timezones = {
        ...allTimezones,
        'Europe/Berlin': 'Frankfurt',
    }
    const { options } = useTimezoneSelect({
        labelStyle,
        timezones,
    })

    const timezoneOffsets = options.reduce((acc, option) => {
        acc[option.value] = option.offset * 60
        return acc
    }, {})

    const formatZone = (isoString, timezone) => {
        if (isoString) {
            const offset = timezoneOffsets[timezone] || 0
            const date = moment.utc(isoString)
            date.add(offset, 'minutes')
            return date.format('DD/MM/YYYY HH:mm:ss')
        }
        return null
    }
    const column2 = [
        {
            id: 'id',
            label: 'No.',
            width: '5%',
            sortable: true,
            align: 'left',
        },
        {
            id: 'timeuse',
            label: 'timetamp',
            width: '10%',
            sortable: true,
            align: 'left',
        },
        {
            id: 'device_id',
            label: 'ID Name',
            width: '20%',
            sortable: true,
            align: 'left',
        },
        {
            id: 'name_notification_setting',
            label: 'Notification Name',
            width: '20%',
            sortable: true,
            align: 'left',
        },

        {
            id: 'description',
            label: 'messDescriptionage',
            width: '10%',
            sortable: true,
            align: 'left',
        },
        {
            id: 'area',
            label: 'Location',
            width: '10%',
            sortable: true,
            align: 'left',
        },
    ]

    // const today = new Date()
    // const from = new Date(today.setHours(0, 0, 0, 0)) // เริ่มต้นของวัน
    // const to = new Date() // เวลาปัจจุบัน

    // const formatDate = (date) => {
    //     return date.toISOString().replace('T', ' ').substring(0, 19)
    // }
    // const date_from = formatDate(from)
    // const date_to = formatDate(to)

    const pad = (num) => String(num).padStart(2, '0')

    const formatDateLocal = (date, news) => {
        const yyyy = date.getFullYear()
        const mm = pad(date.getMonth() + 1)
        const dd = pad(date.getDate())
        const hh = pad(date.getHours())
        const mi = pad(date.getMinutes())
        const ss = pad(date.getSeconds())
        const formatTime = news ? `${23}:${59}:${59}` : `${hh}:${mi}:${ss}`

        return `${yyyy}-${mm}-${dd} ${formatTime}`
    }

    const to = new Date()

    const from = new Date()
    from.setMonth(from.getMonth() - 3)
    from.setHours(0, 0, 0, 0)

    const date_from = formatDateLocal(from)
    const date_to = formatDateLocal(to, true)

    const handleGetRealTimeLog = useCallback(async () => {
        try {
            const url = `${urlConfig.alarmLog}/${deviceId}?page=${page}&limit=${limit}&date_from=${date_from}&date_to=${date_to}`
            const res = await axiosInstance.get(url)
            const resData = res.data.message
            const dataWithArea = resData.map((item, index) => ({
                id: index + 1 + (page - 1) * limit,
                ...item,
                area: deviceData?.description,
                timeuse: formatZone(item.createdAt, localTimezone),
            }))
            setData(dataWithArea)

            setFoot({
                page: res.data.meta.page,
                limit: res.data.meta.limit,
                total: res.data.meta.total,
                hasNext: res.data.meta.hasNext,
            })
            handleOpen({ open: false })
        } catch (error) {
            handleOpen({
                open: true,
                message: `${error.response?.data.message}`,
                isSuccess: false,
            })
        }
    }, [deviceId, deviceData, handleOpen, page, limit])

    const handleWebSocketData = useCallback(() => {
        if (typeAlarm.device_id !== deviceId || !typeAlarm.data) return
        const dataWithArea = typeAlarm.data.map((item, index) => ({
            id: index + 1,
            ...item,
            area: deviceData?.description,
            timeuse: formatZone(item.createdAt, localTimezone),
        }))
        setDataType(dataWithArea.slice(0, 5))
    }, [typeAlarm, deviceData, deviceId])

    useEffect(() => {
        if (connectedWB && typeAlarm.device_id === deviceId) {
            handleWebSocketData()
        }
    }, [handleWebSocketData])

    useEffect(() => {
        let timeoutId
        let cancelled = false

        // const fetchLoop = async () => {
        //     if (!connectedWB || !dataType[0]) {
        //         console.log('WebSocket not connected or no data available')

        //         try {
        //             await handleGetRealTimeLog()
        //         } catch (error) {
        //             console.error('handleGetRealTimeLog failed:', error)
        //         }

        //         if (!cancelled) {
        //             timeoutId = setTimeout(fetchLoop, 3000)
        //         }
        //     }
        // }
        const fetchLoop = async () => {
            try {
                await handleGetRealTimeLog()
            } catch (error) {
                console.error('handleGetRealTimeLog failed:', error)
            }
            if (!cancelled) {
                timeoutId = setTimeout(fetchLoop, 5000)
            }
        }
        fetchLoop()
        return () => {
            cancelled = true
            clearTimeout(timeoutId)
        }
    }, [])

    useEffect(() => {
        handleGetRealTimeLog()
    }, [page, limit, connectedWB, dataType])

    return (
        <Grid container>
            <Typography mb={1} variant='h5'>
                Alarm Real-Time
            </Typography>

            <Grid item xs={12}>
                <TableComponents
                    noPadding={true}
                    disableSearch={true}
                    data={data} //disconnect websocket data
                    // data={dataType[0] ? dataType : data}
                    columns={column2}
                    noPagination={true}
                />
                {/* <Box
                    sx={{
                        background: 'white',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        p: '15px',
                        gap: '8px',
                        alignContent: 'center',
                    }}
                >
                    <select
                        value={limit}
                        onChange={(e) => {
                            setData('')
                            setLimit(e.target.value)
                            setPage(1)
                        }}
                        style={{
                            marginRight: '30px',

                            fontSize: '14px',
                            background: 'white',
                            border: '1px solid lightgrey',
                            borderRadius: '5px',
                            transition: 'border 0.3s, font-weight 0.3s',
                        }}
                    >
                        {limitOptions.map((item, index) => (
                            <option value={item} key={index}>
                                {item}
                            </option>
                        ))}
                    </select>
                    <Box
                        style={{ fontSize: '14px' }}
                        display={'flex'}
                        alignItems={'center'}
                    >
                        {foot &&
                            `${(foot.page - 1) * foot.limit + 1} - ${Math.min(
                                foot.page * foot.limit,
                                foot.total,
                            )} of ${foot.total}`}
                    </Box>
                    <button
                        disabled={foot && foot.page === 1}
                        onClick={() => {
                            setData('')
                            setPage(page - 1)
                        }}
                        style={{
                            background: 'white',
                            border: '1px solid lightgrey',
                            padding: '5px',
                            borderRadius: '5px',
                            cursor: foot && foot.page === 1 ? '' : 'pointer',
                            transition: 'border 0.3s, font-weight 0.3s',
                        }}
                    >
                        <ArrowBackIosNewRoundedIcon
                            fontSize='10px'
                            sx={{
                                color:
                                    foot && foot.page === 1
                                        ? 'lightgrey'
                                        : 'black',
                            }}
                        />
                    </button>
                    <button
                        onClick={() => {
                            setData('')
                            setPage(page + 1)
                        }}
                        disabled={
                            foot &&
                            (!foot.hasNext ||
                                foot.page ===
                                    Math.ceil(foot.total / foot.limit))
                        }
                        style={{
                            background: 'white',
                            border: '1px solid lightgrey',
                            padding: '5px',
                            borderRadius: '5px',
                            cursor:
                                foot &&
                                (!foot.hasNext ||
                                    foot.page ===
                                        Math.ceil(foot.total / foot.limit)) &&
                                'pointer',
                            transition: 'border 0.3s, font-weight 0.3s',
                        }}
                    >
                        <ArrowForwardIosRoundedIcon
                            fontSize='10px'
                            sx={{
                                color:
                                    foot &&
                                    (!foot.hasNext ||
                                        foot.page ===
                                            Math.ceil(foot.total / foot.limit))
                                        ? 'lightgrey'
                                        : 'black',
                            }}
                        />
                    </button>
                </Box> */}
            </Grid>
        </Grid>
    )
}
